var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"cv-breadcrumb",class:[(_vm.carbonPrefix + "--breadcrumb"), ( _obj = {}, _obj[(_vm.carbonPrefix + "--breadcrumb--no-trailing-slash")] = _vm.noTrailingSlash, _obj )],attrs:{"aria-label":_vm.ariaLabel}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }